<template>
  <form v-if="editableQuery" class="page-content -no-padding" @submit.prevent="submit" @change="formChange">
    <div class="page-content -auto-height -form">
      <query-general :query="editableQuery" :errors="editableErrors" @change="generalChange"></query-general>
    </div>

    <div class="page-content -auto-height">
      <label class="section-title -strong -mb">On Match</label>

      <div class="halves">
        <!--
      --><query-selector
          :query-id="editableQuery.id"
          :selected-query-id="editableQuery.on_match.move_to_query"
          :label="'Move to query:'"
          @change="editableQuery.on_match.move_to_query = $event"
        ></query-selector
        ><!--
      --><query-selector
          :query-id="editableQuery.id"
          :selected-query-id="editableQuery.on_match.set_next_query"
          :label="'Set next query:'"
          @change="editableQuery.on_match.set_next_query = $event"
        ></query-selector>
      </div>

      <query-setters
        :query="editableQuery"
        :type="'on_match'"
        :errors="editableErrors"
        @change="editableQuery.on_match.setters = $event"
      ></query-setters>
      <query-responses
        :query="editableQuery"
        :type="'on_match'"
        :errors="editableErrors"
        @change="editableQuery.on_match.responses = $event"
      ></query-responses>
      <query-form-fields
        :query="editableQuery"
        :type="'on_match'"
        :errors="editableErrors"
        @change="editableQuery.on_match.form_fields = $event"
      ></query-form-fields>
    </div>

    <div class="page-content -auto-height -form">
      <label class="section-title -strong -mb">On Mismatch</label>

      <div class="halves">
        <!--
      --><query-selector
          :query-id="editableQuery.id"
          :selected-query-id="editableQuery.on_mismatch.move_to_query"
          :label="'Move to query:'"
          @change="editableQuery.on_mismatch.move_to_query = $event"
        ></query-selector
        ><!--
      --><query-selector
          :query-id="editableQuery.id"
          :selected-query-id="editableQuery.on_mismatch.set_next_query"
          :label="'Set next query:'"
          @change="editableQuery.on_mismatch.set_next_query = $event"
        ></query-selector>
      </div>

      <query-setters
        :query="editableQuery"
        :type="'on_mismatch'"
        :errors="editableErrors"
        @change="editableQuery.on_mismatch.setters = $event"
      ></query-setters>
      <query-responses
        :query="editableQuery"
        :type="'on_mismatch'"
        :errors="editableErrors"
        @change="editableQuery.on_mismatch.responses = $event"
      ></query-responses>
      <query-form-fields
        :query="editableQuery"
        :type="'on_mismatch'"
        :errors="editableErrors"
        @change="editableQuery.on_mismatch.form_fields = $event"
      ></query-form-fields>
    </div>

    <div class="page-content -auto-height">
      <action-button
        :text="buttonText"
        :state="editableFormState"
        @pressed="submit"
        @revertState="revertState"
      ></action-button>
    </div>
  </form>
</template>

<script>
import actionButton from "@/components/actionButton";
import queryFormFields from "@/components/queryForm/formFields";
import queryGeneral from "@/components/queryForm/general";
import queryResponses from "@/components/queryForm/responses";
import querySelector from "@/components/queryForm/selector";
import querySetters from "@/components/queryForm/setters";

export default {
  name: "QueryForm",

  components: { queryGeneral, querySelector, querySetters, queryResponses, queryFormFields, actionButton },

  props: {
    query: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    formState: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: "Create Query"
    }
  },

  data() {
    return {
      editableQuery: null,
      editableErrors: {},
      editableFormState: "normal"
    };
  },

  watch: {
    query() {
      this.editableQuery = this.query;
      this.editableErrors = {};
      this.editableFormState = "normal";
    },
    errors(errors) {
      this.editableErrors = errors;
    },
    formState(formState) {
      this.editableFormState = formState;
    }
  },

  mounted() {
    this.editableQuery = this.query;
    this.editableErrors = this.errors;
    this.editableFormState = this.formState;
  },

  methods: {
    generalChange(data) {
      this.editableQuery.label = data.label;
      this.editableQuery.matcher_type = data.matcher_type;
      this.editableQuery.matchers = data.matchers;
    },

    submit() {
      if (this.editableFormState !== "normal") return;

      this.$emit("submit", {
        id: this.editableQuery.id,
        label: this.editableQuery.label,
        matcher_type: this.editableQuery.matcher_type,
        matchers: this.editableQuery.matchers,
        on_match: this.editableQuery.on_match,
        on_mismatch: this.editableQuery.on_mismatch
      });
    },

    revertState() {
      this.$emit("revertState");
    },

    formChange() {
      this.$emit("changeMade");
    }
  }
};
</script>
